import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCommentsComponent } from "./med-icon-comments.component";

@NgModule({
  declarations: [
    MedIconCommentsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCommentsComponent,
  ],
})
export class MedIconCommentsModule { }
